import type {
  DocumentTemplatePublic,
  DocumentTemplateUpsert,
} from "@common/client"
import { z } from "zod"

export const TEMPLATE_PARTS = ["body", "header", "footer"] as const

export type TemplatePart = (typeof TEMPLATE_PARTS)[number]

export const PART_LABELS: Record<TemplatePart, string> = {
  body: "Body",
  header: "Header",
  footer: "Footer",
}

export const templateSchema = z.object({
  body: z.string().min(1, "The body can't be empty."),
  header: z.string(),
  footer: z.string(),
})

export type TemplateFormInput = z.input<typeof templateSchema>

export function templateDefaults(
  template: DocumentTemplatePublic,
): TemplateFormInput {
  return {
    body: template.body,
    header: template.header ?? "",
    footer: template.footer ?? "",
  }
}

export function templatePayload(
  values: TemplateFormInput,
): DocumentTemplateUpsert {
  return {
    body: values.body,
    header: values.header || null,
    footer: values.footer || null,
  }
}
